import { Collapse, CollapseItem, Button, Popover, Select, Option, } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment';

export default {
    name: 'RaceCardView',
    props: ['cardData'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            activeRaceId: null,
            no: 'No'
        };
    },
    computed: {
        isAnyRacesLoaded() {
            return this.cardData;
        }
    },
    methods: {
        closeCard() {
            this.$parent.isCardVisible = false;
        },
        isYes(input) {
            if (input == this.no) {
                return true;
            }
            else { return false; }
        }
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/race-events/race-calendar/card-view/card-view.js